import { APIResponseType, createThunkCase } from "@/redux/helper/thunk";
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { thunks } from "./thunk";
import { AsyncThunk } from "@reduxjs/toolkit";

interface APTStateType {
  businessList: APIResponseType;
  businessDetails: APIResponseType;
}

const APIState: APTStateType = {
  businessList: {
    data: null,
    loading: false,
    meta: null,
  },
  businessDetails: {
    data: null,
    loading: false,
    meta: null,
  },
};

interface stateType extends APTStateType {
  currentFormStep: number;
}

const initialState = {
  currentFormStep: 0,
  ...APIState,
} satisfies stateType as stateType;

export const slice = createSlice({
  name: "user_buyer_business",
  initialState,
  reducers: {
    setCurrentFormStep: (state, action: PayloadAction<number>) => {
      state.currentFormStep = action?.payload;
    },
    setFormValues: (state, action: PayloadAction<any | null>) => {
      if (action?.payload) {
        state.businessDetails.data = {
          ...state.businessDetails.data,
          ...action?.payload,
        };
      } else {
        state.businessDetails = { ...initialState.businessDetails };
      }
    },
  },
  extraReducers: (builder) => {
    Object.entries(thunks).forEach(([_, thunk]) => {
      createThunkCase(builder, thunk as AsyncThunk<any, any, any>, APIState);
    });
  },
});

export const Actions = slice.actions;
export default slice.reducer;